import { render } from "./TextAreaField.vue?vue&type=template&id=ae5ce604"
import script from "./TextAreaField.vue?vue&type=script&lang=js"
export * from "./TextAreaField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__